function InitMainAddressCheckboxes () {
  const checkboxes = document.querySelectorAll('.main-address-checkbox')

  for (const checkbox of checkboxes) {
    checkbox.addEventListener('change', () => {
      const checked = checkbox.checked

      checkboxes.forEach(checkbox => { checkbox.checked = false })

      checkbox.checked = checked
    })
  }
}

export { InitMainAddressCheckboxes }
